/* ====================================================================
   FLOOREVER — AJOUT PANIER RAPIDE
   (sections/floorever-produit-complements.liquid)
   Vanilla JS, chargé en defer, aucune dépendance.

   Intercepte les formulaires [data-quick-add] (cartes accessoires) :
   sans JS, le <form> poste nativement vers /cart/add (repli fonctionnel).
   Avec JS : POST AJAX vers /cart/add.js, retour visuel « ✓ Ajouté »
   3 secondes sur le bouton, message d'erreur en role=status sinon.

   Routes lues sur la racine [data-compl] : data-route-cart-add et
   data-route-cart (SANS suffixe .js — ajouté ici, même contrat que
   floorever-product.js).

   Après ajout : mise à jour de la pastille panier du header
   (.cart-link .cart-count, créée si absente) puis émission de
   document -> CustomEvent 'floorever:cart:change'
   (detail.cart = payload /cart.js) — contrat commun du thème.
   ==================================================================== */
(function () {
  'use strict';

  /* Met à jour la pastille du header et notifie le reste du thème
     (même comportement que floorever-product.js). */
  function majCompteurPanier(routePanier) {
    /* Module commun (assets/floorever-cart.js) : pastille + événement, source normalisée. */
    if (window.FloorEverCart) return window.FloorEverCart.rafraichir(routePanier, 'complements');
    fetch(routePanier, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var lien = document.querySelector('.cart-link');
        if (lien) {
          var compteur = lien.querySelector('.cart-count');
          if (!compteur && panier.item_count > 0) {
            compteur = document.createElement('span');
            compteur.className = 'cart-count';
            compteur.setAttribute('aria-hidden', 'true');
            lien.appendChild(compteur);
          }
          if (compteur) compteur.textContent = panier.item_count;
          lien.setAttribute(
            'aria-label',
            'Panier, ' + panier.item_count + ' article' + (panier.item_count > 1 ? 's' : '')
          );
        }
        document.dispatchEvent(
          new CustomEvent('floorever:cart:change', { detail: { cart: panier, source: 'complements' } })
        );
      })
      .catch(function () { /* silencieux : la pastille sera juste obsolète */ });
  }

  function initForm(form) {
    if (form.dataset.quickAddInit === 'true') return;
    form.dataset.quickAddInit = 'true';

    var racine = form.closest('[data-compl]');
    var routeAjout = ((racine && racine.dataset.routeCartAdd) || '/cart/add') + '.js';
    var routePanier = ((racine && racine.dataset.routeCart) || '/cart') + '.js';

    var btn = form.querySelector('[data-quick-add-submit]');
    var label = form.querySelector('[data-quick-add-label]');
    var statut = form.querySelector('[data-quick-add-status]');
    var labelBase = label ? label.textContent.trim() : '';
    var enCours = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault(); /* repli sans JS : submit natif vers /cart/add */
      if (enCours || (btn && btn.disabled)) return;

      var champId = form.querySelector('[name="id"]');
      var id = champId ? parseInt(champId.value, 10) : 0;
      var champQte = form.querySelector('[name="quantity"]');
      var qte = champQte ? parseInt(champQte.value, 10) || 1 : 1;
      if (!id) return;

      enCours = true;
      if (btn) btn.setAttribute('aria-busy', 'true');
      if (statut) {
        statut.hidden = true;
        statut.textContent = '';
      }

      fetch(routeAjout, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qte }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('ajout impossible (' + r.status + ')');
          return r.json();
        })
        .then(function () {
          if (btn && label) {
            label.textContent = btn.dataset.labelSuccess || labelBase;
            btn.classList.add('is-added');
            window.setTimeout(function () {
              label.textContent = labelBase;
              btn.classList.remove('is-added');
            }, 3000);
          }
          majCompteurPanier(routePanier);
        })
        .catch(function () {
          if (statut) {
            statut.textContent = statut.dataset.msgError || '';
            statut.hidden = !statut.textContent;
          }
        })
        .finally(function () {
          enCours = false;
          if (btn) btn.removeAttribute('aria-busy');
        });
    });
  }

  function initTout(scope) {
    (scope || document).querySelectorAll('[data-quick-add]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTout(); });
  } else {
    initTout();
  }

  /* Rechargement de section dans l'éditeur de thème. */
  document.addEventListener('shopify:section:load', function (e) {
    initTout(e.target);
  });
})();
